import apiClient from '@/api/apiClient.js';
import apiClient3 from '@/api/apiClient.js';
import { getInstProfesId, getClinicalHistoriesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    nameLLaveCo: {},
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    nameLLaveCo(state) {
      return state.nameLLaveCo;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertNameLLaveCo(state, nameLLaveCo) {
      state.nameLLaveCo = nameLLaveCo;
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.testCorrectorsSchema();
        const schema = res.data;
        let coPackage = schema.coPackage;

        const id = getClinicalHistoriesId();
        const res2 = await apiClient.dataTestCorrectors(id);
        const dataCorrectors = res2.data.data;

        for (let i = 0; i < coPackage.length; i++) {
          let { correctors } = coPackage[i];

          for (let n = 0; n < correctors.length; n++) {
            let groups = correctors[i].group;

            for (let m = 0; m < Object.keys(groups).length; m++) {
              let idCo = coPackage[i].correctors[n].group[m].id;

              if (dataCorrectors.includes(idCo)) {
                coPackage[i].correctors[n].group[m].check = '✔';
              }
            }
          }
        }

        schema.coPackage = coPackage;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async loadFileLLaveCo({ commit }) {
      try {
        const id = getInstProfesId();
        const res = await apiClient.dataLlaveCo(id);
        let file = res.data.data;

        let nameLLaveCo;
        if (file === true) {
          nameLLaveCo = 'LlaveCo.xlsx';
        }
        commit('insertNameLLaveCo', nameLLaveCo);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async submitFileLLaveCo({ dispatch }, file) {
      try {
        const formData = new FormData();
        formData.append('file', file);

        const id = getInstProfesId();
        const res = await apiClient3.submitLlaveCo(id, formData);

        if (res.status === 200) {
          dispatch('loadFileLLaveCo', true);
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    async deleteLlaveCo({ dispatch }) {
      try {
        const id = getInstProfesId();
        await apiClient.deleteLlaveCo(id);

        dispatch('loadFileLLaveCo');
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  },
};
